<div class="container" >
<div class="content">

  <h1 class="title">Log In to Datanyze</h1>

  <div class="social-btns-container">
    <dn-social-btn [text]="'Log in with Google'" [loading]="mainBtnDisabled" [size]="buttonSize.EXTRA_LARGE" [icon]="socialsIcon.GOOGLE" (clickButton)="googleLoginClick()" />
    <dn-social-btn [text]="'Log in with Office 365'" [loading]="mainBtnDisabled" [size]="buttonSize.EXTRA_LARGE" [icon]="socialsIcon.OFFICE" (clickButton)="officeLoginClick()" />  
  </div>

  <div class="form-separator">Or</div>

  <form class="form" [formGroup]="loginForm">

      <div class="form-inputs">

        <div>
          <dn-form-input
            inputType="text"
            [placeholder]="'Email Address'"
            [inputId]="formIds.EMAIL" [formControlName]="'email'" [formGroup]="loginForm" [iconType]="iconType.EMAIL"
            [errorMessage]="emailErrorMessage" (componentFocus)="onInputFocus($event)" (focusOut)="elementOnFocusOut($event)" />
        </div>

        <div>
          <dn-form-input
            inputType="password"
            [showValidationIndicators]="false"
            [placeholder]="'Password'"
            [inputId]="formIds.PASSWORD" [formControlName]="'password'" [errorMessage]="passwordMessage"
            [formGroup]="loginForm"
            [iconType]="iconType.LOCK"
            [showValueStatus]="false" [showViewPassword]="true" (componentFocus)="onInputFocus($event)"
            (focusOut)="elementOnFocusOut($event)" />
        </div>


        <!-- <dn-checkbox (checkboxStateChanged)="rememberMe=$event" [text]="'Remember me'">
        </dn-checkbox> -->

      </div>

    </form>

    <div class="error-wrapper">
      <span class="error">
        {{ errorMessage }}
      </span>
      <a *ngIf="displayContactSupport" class="link" target="_blank" [href]="contactSupportLink">Contact Support</a>
    </div>


    <div class="btn-wrapper" EnterPress>
      <dn-primary-btn type="submit"  [loading]="loading" [ngClass]="enterPressClass" [disabled]="mainBtnDisabled" [text]="loginBtnText" (clickButton)="login()" />
    </div>

    <div class="forgot-password" (click)="forgotPassword()">
      Forgot Password?
    </div>

    <!-- Don’t have an account? -->
    <div *ngIf="displayGoToSignUp" class="signup">
      <span>
        Don’t have an account?
      </span>
      <span class="goto" (click)="signup()">Sign Up</span>
    </div>

  </div>
</div>
